<template>
    <div class="survey-container">
        <div class="survey"
            @click="onAnswer(item)"
            v-for="(item, index) in list"
            :key="index">
            <div class="logo">
                <div class="logo-inner">
                    <img :src="item.logo"/>
                </div>
            </div>
            <div class="survey-inner">
                <span class="survey-title">{{ item.name }}</span>
                <div class="survey-option">
                    <span>奖励总额：</span>
                    <span>{{ getAmount(item) }}元</span>
                </div>
                <div class="survey-option">
                    <span>问卷份数：</span>
                    <span>{{ item.totalNum }}</span>
                </div>
                <div class="survey-option">
                    <span>问卷状态：</span>
                    <span>{{ getStatus(item.status) }}</span>
                    <div class="icon_bg">
                        <img class="hongbao"
                            v-if="item.raffleAmount > 0"
                            :src="hongbao"/>
                        <i class="iconfont icon-lock suo_img"
                            v-if="item.isPassword === true"/>
                        <i class="iconfont icon-jingzhun jingzhun_img"
                            v-if="item.disWay === 2"/>
                    </div>
                </div>
                <div class="btn-container">
                    <div class="home-btn"
                        @click.stop="onShare(item)"
                        v-if="(item.status === 2 ||
                            item.status == 6 ||
                            item.status == 7 ||
                            item.status === 10) && !item.thirdUrl">
                        转发
                    </div>
                    <div class="home-btn primary"
                        v-if="item.status === 2">
                        作答
                    </div>
                    <span v-else-if="item.status === 6" class="last">
                        已作答
                    </span>
                    <span v-else-if="item.status === 7"></span>
                </div>
            </div>
        </div>
        <share-dialog v-if="shareDialogShow"
            width="90%"
            top="20vh"
            :show.sync="shareDialogShow"
            :share-url="shareUrl"
            :code-url="codeUrl">
        </share-dialog>
    </div> 
</template>

<style scoped lang="scss">
.survey-container{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.survey{
    display: flex;
    flex-direction: column;
    width: 8.93rem;
    background: #E7F2FF;
    border-radius: 9px;
    padding: .27rem .37rem;
    margin-bottom: .37rem;
    position: relative;
}
.logo {
    .logo-inner {
        display: flex;
        align-items: center;
        padding-bottom: 5px;
        img {
            max-height: 30px;
            object-fit: contain;
        }
    }
}
.survey-inner{
    display: flex;
    flex-direction: column;
}
.survey-title{
    display: -webkit-box;
    font-size: 0.48rem;
    line-height: 0.69rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;  
    -webkit-box-orient: vertical;
    margin-bottom: .37rem;
}
.survey-option{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 0.37rem;
    color: #999999;
    margin-bottom: .21rem;
}
.icon_bg {
    display: flex;
    margin-left: 3px;
    color: #e38d35;
    .hongbao {
        width: 20px;
        height: 20px;
    }
    .suo_img {
        width: 20px;
        height: 20px;
        font-size: 20px;
        color: #1287c4;
    }
    .jingzhun_img {
        width: 20px;
        height: 20px;
        font-size: 20px;
    }
}
.btn-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    right: 0;
    bottom: .27rem;
    span{
        width: 53px;
        color: #666666;
    }
    span.last{
        width: 60px;
        text-align: center;
        margin-right: .37rem;
    }
}
.home-btn{
    width: 1.6rem;
    line-height: 0.85rem;
    border-radius: 16px;
    padding: 0;
    margin-right: .37rem;
}
</style>

<script>
import { DataMarket } from '@/models/data-market'
import ShareDialog from '@/components/data-market/share-dialog.vue'
export default {
    props: {
        list: Array
    },
    data(){
        return {
            shareUrl: '',
            codeUrl: '',
            shareDialogShow: false,
            hongbao:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACXUlEQVRYR+2XS2sTURTH/+dmMknTxMZobQ2SSG3xgdJldOXjAwhuRdCFe3ciuHThlxDEunHjwi9gloogLqRF8Zlok5Ki0TiZZpKZe2RmMtI8jDZzQYTc3bz+53f+55x7GcI/XjQsfu3UocVqme6zQrjlXOscPfm81S85FKB68siZes0pftmUShD2zApkp61M+mW5/tcABBTLbzuwrHAMsRiQW4wi3jR3DmBtSZTfO6EIcgsRxKbEeABu5K81B+OWwrU+sy/iJTCWA0Hq45QisD7QCAUwTikC65UA7LQU261XBuAKrX+wYZqjd4d+65UC2G1G6V0HydMzSBZSSByOAwSYr1swnv5Ao9hAv/VKASgpYF+Yg358euhodtaaiDysgY3B0Q3VhEE0cTULWkqM3Bf4jQl5pzLwTmgAWk5CXJz3hZlhfRLQs+yVoL0OxA4wIPydXT7YAL8weiBCA4jL86BjST9Ai2HXBWTLj0E6oO9lUKzL96oJebeqFiBy8yCwS/NE2xUCu+eUDUBjiCkCRQAt7U8IGzbkrY+KAW7kgd3RXw5AEhyDwMzQUvAAAgfwrQPndkktgLg0BzqRGnCA3TaIAiQAfb8EiMBrBuS9DbUAdDQBcSXbI2q7pzsDWqa36eVKFbzaVAvgqm13wWtGE5AOvBIEi1cNyJXe7N1noafAC6AB4vwsqDDTm3L3ip99h3y06Tdn31IDEIjm4xBn06B83O/6sgX5uA6UunM5BE8twND8R9+cAEwcmDjwfzlQKywsMfRrY4z7bz9x7Mb17POK2f/C0J9TlYH/pPUTlbiIMBX3HSsAAAAASUVORK5CYII=",
        }
    },
    components: {
        ShareDialog
    },
    methods: {
        onShare(item) {
            // 查询转发链接、二维码
            DataMarket.getForwardUrlShortUrl(item.shortUrl).then((res) => {
                if (res.success) {
                    this.shareUrl = res.data.url
                    this.codeUrl = res.data.codeUrl
                    this.shareDialogShow = true
                }
            })
        },
        onAnswer(item) {
            if (item.status === 6) {
                this.$dialog.alert({
                    title: "提示",
                    message: "您已作答此问卷",
                })
                return
            } else if (item.status === 7) {
                this.$dialog.alert({
                    title: "提示",
                    message: "您暂未符合此精准发布问卷对用户的要求，请选择其他问卷作答或转发问卷获得奖励分成。"
                })
                return
            } else if (item.status === 10) {
                this.$dialog.alert({
                    title: "提示",
                    message: "当前问卷正在作答人数已达到上限，请稍后再试",
                })
                return
            } else if (item.status !== 2) {
                this.$dialog.alert({
                    title: "提示",
                    message: "该问卷已结束",
                })
                return
            }
            if (item.isLimitAnswerClient) {
                // 1电脑 2手机、小程序 3APP
                if (item.answerClient == 1) {
                    this.$dialog.confirm({
                        title: "请复制链接到电脑端作答",
                        confirmButtonText: "复制链接",
                        message:
                            "./answer.html#/s/" +
                            item.shortUrl +
                            "?sourceType=1"})
                    .then(() => {
                        let aux = document.createElement("input");
                        aux.setAttribute(
                            "value",
                                "./answer.html#/s/" +
                                item.shortUrl +
                                "?sourceType=1"
                        );
                        document.body.appendChild(aux);
                        aux.select();
                        document.execCommand("Copy"); //原生copy方法执行浏览器复制命令
                        document.body.removeChild(aux); //清除input
                        this.$toast("复制成功");
                    });
                    return;
                } else if (item.answerClient == 3) {
                    // 跳转到下载app的页面
                    window.open(
                        "https://download.credamo.com/app/index.html",
                        "_self"
                    );
                    return;
                }
            }
            let url = "";
            if (item.thirdUrl) {
                url = item.thirdUrl;
            } else {
                url = "./answer.html#/s/" + item.shortUrl + "?sourceType=1";
            }
            window.open(url);
        },
        getAmount(item) {
            return this._toDecimal(item.totalAward + item.raffleAmount);
        },
        getStatus(value) {
            switch (value) {
                case 2:
                    return "发布中";
                case 4:
                    return "已完成"; //终止
                case 5:
                    return "已完成"; //完成
                case 6:
                    return "发布中"; //已作答过
                case 7:
                    return "发布中"; //无权限作答
                case 10:
                    return "发布中"; //作答者已满
                default:
                    return "未知";
            }
        },
        _toDecimal(x) {
            var val = Number(x);
            if (!isNaN(parseFloat(val))) {
                val = val.toFixed(2);
            }
            val = val.toString();
            if (val.substr(val.length - 2) === "00") {
                val = val.substr(0, val.length - 3);
            } else if (val.charAt(val.length - 1) === "0") {
                val = val.substr(0, val.length - 1);
            }
            return val;
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/data-market/m/survey-list.vue